/*
 * Autoduft-Trio: ein Klick legt alle drei Autodüfte in den Warenkorb.
 * Buttons tragen data-ma-trio="<variant-id>,<variant-id>,<variant-id>".
 * Was schon im Warenkorb liegt, wird nicht doppelt hinzugefügt. Der 3-für-2-Rabatt
 * kommt von der automatischen Shopify-Aktion, nicht von hier.
 */
(function () {
  if (window.__maTrio) return;
  window.__maTrio = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function setState(btn, state) {
    var label = btn.querySelector('[data-ma-trio-label]') || btn;
    if (!btn.dataset.maTrioText) btn.dataset.maTrioText = label.textContent;
    if (state === 'busy') {
      btn.setAttribute('aria-busy', 'true');
      label.textContent = btn.dataset.maTrioBusy || 'Wird hinzugefügt …';
    } else if (state === 'error') {
      btn.removeAttribute('aria-busy');
      label.textContent = btn.dataset.maTrioError || 'Das hat nicht geklappt. Bitte erneut versuchen.';
    } else {
      btn.removeAttribute('aria-busy');
      label.textContent = btn.dataset.maTrioText;
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-ma-trio]');
    if (!btn) return;
    event.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true' || btn.disabled) return;

    var ids = btn.dataset.maTrio.split(',').filter(Boolean).map(Number);
    if (!ids.length) return;
    setState(btn, 'busy');

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = cart.items.map(function (item) { return item.variant_id; });
        var missing = ids.filter(function (id) { return inCart.indexOf(id) === -1; });
        if (!missing.length) return;
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: missing.map(function (id) { return { id: id, quantity: 1 }; }) })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart/add ' + r.status);
        });
      })
      .then(function () {
        // Direkt in den Checkout — der 3-für-2-Rabatt wird dort automatisch abgezogen.
        window.location.href = '/checkout';
      })
      .catch(function () {
        setState(btn, 'error');
        setTimeout(function () { setState(btn, 'idle'); }, 4000);
      });
  });
})();
